// src/hooks/useUserData.js
// -----------------------------------------------------------------------------
// Wraps the generic useTableData hook specifically for User CRUD operations.
// Automatically points to userService.js, which calls the real backend endpoints.
// -----------------------------------------------------------------------------
import useTableData from './useTableData';
import userService from '../api/userService';

export function useUserData(options = {}) {
  return useTableData(userService, {
    idKey: 'id',
    itemName: 'User',
    initialSort: { key: 'id', direction: 'desc' },
    ...options,
  });
}

export default useUserData;
